import {axios} from '../../helpers/axiosService/index'
interface PropertyParams {
  searchTerm?: string;
  chains?: string[];
  propertyID?: string | number;

}
class ApiCallsFactory {
  private url: string
  private token: string
  private body: object | undefined
  private baseURL = process.env.REACT_APP_HOST || 'https://contentsuite.derbysoft-test.com/content-manager'
  private externalUrl: string
  private customToken: string
  

  constructor(
    url: string,
    token?: string | any,
    body?: object,
    customToken?: string | any,
   
  ) {
    this.url = `${this.baseURL}${url}`
    this.token = token
    this.body = body
    this.externalUrl = url
    this.customToken = customToken
   
  }

  public async getData(params?: URLSearchParams): Promise<object> {
    try {
      const { data } =  await axios.get(this.url, {
        headers: {
          'x-access-token': this.token
        },
        params: params
      },
      )

      return data
    } catch (error: any) {
      console.log(error)
      return error
    }
  }

  public async getDataWithCompanyId(): Promise<object> {
    try {
      const { data } =  await axios.get(this.url, {
        headers: {
          'x-access-token': this.token,
          'companyId' : this.customToken
        },
      },
      )

      return data
    } catch (error: any) {
      console.log(error)
      return error
    }
  }

  public async getDataWithCookies() : Promise<object> {
    try {
      const response =  await axios.get(this.url, {
        withCredentials: true,
      })
      return response.data
    } catch (error: any) {
      console.log(error)
      return error
    }
  }

  public async getExternalData() : Promise<object> {
    try {
      const { data } =  await axios.get(this.externalUrl, {
        withCredentials: true,
      })
      return data
    } catch (error: any) {
       console.log(error)
      return error
    }
  }

  public async postData(): Promise<object> {
    try {
      const response: any = await axios.post(this.url, this.body, {
        headers: {
          'x-access-token': this.token
        }
      })
      return response.data
    } catch (error: any) {
      const err: any =  await { error }
      const errorReason = err && err.error && err.error.response.data && err.error.response.data.errors && err.error.response.data.errors[0] && err.error.response.data.errors[0].message ? err.error.response?.data.errors[0].message : 'Something were wrong'
      throw Error(errorReason)
    }
  }

  public async putData(): Promise<object> {
    try {
      const response: any = await axios.put(this.url, this.body, {
        headers: {
          'x-access-token': this.token
        }
      })
      return response.data
    } catch (error) {
      const err: any =  await { error }
      const errorReason = err && err.error && err.error.response.data && err.error.response.data.errors && err.error.response.data.errors[0] && err.error.response.data.errors[0].message ? err.error.response?.data.errors[0].message : 'Something were wrong'
      throw Error(errorReason)
    }
  }

  public async deleteData(): Promise<object> {
    try {
      const response = await axios.delete(this.url, {
        headers: {
          'x-access-token': this.token
        },
        data: this.body
      })
      return response.data
    } catch (error: any) {
      console.log(error)
      return error
    }
  }

  public async refreshToken(): Promise<object> {
    try {
      const response: any = await axios.post(this.url, this.body, {
        headers: {
          'x-refresh-token': this.token
        }
      })
      return response.data
    } catch (error) {
      const err: any = { error }
      const errorReason = err && err.error && err.error.response.data && err.error.response.data.errors && err.error.response.data.errors[0] && err.error.response.data.errors[0].message ? err.error.response?.data.errors[0].message : 'Something were wrong'
      throw Error(errorReason)
    }
  }

}

export {
  ApiCallsFactory
}
